import React from "react";
import Download from "../../../assets/icon/Download-Icon3.svg";

const DownloadCSVButton = ({
  monthsdata,
  valuedata1,
  valuedata2,
  heading1,
  filenamedata,
  download
}) => {
  const handleDownload = () => {
    // Data
    if(download==true){
    const value1 = valuedata1;
    const value2 = valuedata2?valuedata2:[];
    const months = monthsdata;
    const arr = [];

    // Preparing the data
    for (let i = 0; i < value1?.length; i++) {
      debugger;
      const row = {
        Months: months[i],
        value1: Number(value1[i]).toFixed(2),
      };

      // Only add value2 if it's available
      if (value2 && value2[i] !== undefined) {
        row.value2 = Number(value2[i]).toFixed(2);
      }

      arr.push(row);
    }

    // Headers for CSV file
    const headers = heading1;

    // Convert the data into CSV format
    const csvData = arr.reduce((acc, row) => {
      const { Months, value1, value2 } = row;

      // Check if value2 exists before adding it to the row
      if (value2 !== undefined) {
        acc.push([Months, value1, value2].join(","));
      } else {
        acc.push([Months, value1].join(","));
      }

      return acc;
    }, []);

    // Combine headers and data into the CSV string
    const csvContent = [headers.join(","), ...csvData].join("\n");

    // Triggering the download
    const downloadFile = (data, fileName, fileType) => {
      const blob = new Blob([data], { type: fileType });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
    };

    downloadFile(csvContent, filenamedata, "text/csv");
}
  };

  return (
    <div>
      <img className="dow_hover" onClick={handleDownload} src={Download} alt="Download CSV" />
      {/* <button>Download CSV File</button> */}
    </div>
  );
};

export default DownloadCSVButton;
